<template lang="pug">
.payment-step
  validation-provider(:rules="{ required: { allowFalse: false } }")
    input.hidden(type="checkbox" :value="!!payment.id")

  .panel.mb-8
    .box
      .preview
        .icon
          svg(
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            //- Dollar
            //- d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"

            //- Euro
            //- d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            )
        .data
          .field-preview
            .label Gesamtsumme
            .field-value
              h3.text-2xl {{ grandTotal | moneyFormat(currency) }}
      template(v-if="checkboxes.length")
        hr.my-4
        Checkbox(
          v-for="(checkbox, i) in checkboxes"
          :key="checkbox.id"
          :data="checkbox"
          :show-divider="i + 1 < checkboxes.length"
          @validate="$emit('validate')"
        )
      template(v-if="methods.length === 1")
        hr.my-4
        PaymentMethod(
          v-for="(method, i) in methods" :key="method.id"
          :data="method"
          :active="method.id === payment.id"
          :show-divider="i + 1 < methods.length"
          :show-label="true"
          :valid="valid"
          @select="select"
          @validate="$emit('validate')"
        )

  .no-payment-methods.mb-4(v-if="!methods.length")
    .alert.error
      p Momentan stehen keine Zahlungsmethoden zur Verfügung.

  .payment-methods(v-if="methods.length > 1")
    h4.panel-heading Zahlungsmethode
    .panel.mb-8
      .box
        PaymentMethod(
          v-for="(method, i) in methods" :key="method.id"
          :data="method"
          :active="method.id === payment.id"
          :show-divider="i + 1 < methods.length"
          :valid="valid"
          @select="select"
          @validate="$emit('validate')"
        )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { get } from '@/helpers';

import { ValidationProvider } from 'vee-validate';
import PaymentMethod from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/PaymentMethod';
import Checkbox from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Checkbox';

export default {
    name: 'PaymentStep',
    props: {
        sections: {
            type: Array,
            required: false
        },
        valid: {
            type: Boolean,
            default: true
        }
        // form: {
        //   type: Object,
        //   required: true
        // }
    },
    components: {
        ValidationProvider,
        PaymentMethod,
        Checkbox
    },
    computed: {
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        checkboxes() {
            const sections = this.sections || [];
            return sections.filter(el => el.key === 'checkbox');
        },
        methods() {
            return get(this.cms, 'shop.paymentMethods') || [];
        },
        payment: {
            get() {
                return this.checkout.form.payment;
            },
            set(value) {
                this.setPayment(value);
            }
        },
        ...mapGetters({
            cms: 'CMS',
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            shippingFee: 'shop/shippingFee',
            checkout: 'shop/checkout',
            taxTotal: 'shop/taxTotal',
            grandTotal: 'shop/grandTotal',
            cart: 'shop/cart'
        })
    },
    methods: {
        select(method) {
            this.payment = method;
        },
        ...mapMutations({
            setPayment: 'shop/setCheckoutFormPayment'
        })
    },
    mounted() {
        // !this.payment.id && this.methods.length === 1
        // if (!this.payment.id && this.methods.length >= 1) {
        //     this.payment = this.methods[0];
        // }
    }
};
</script>

<style lang="sass" scoped>
.no-payment-methods
  width: 100%
  @screen md
    @apply mx-auto
    width: 635px

.payment-step
  width: 100%
  @screen md
    width: auto
</style>
